import React, { useMemo } from "react";
import "./StepProgress.css";

export function StepProgress({ value, maxValue }) {
  const ratio = useMemo(() => Math.min(Math.max(value / maxValue, 0), 1), [value, maxValue]);

  return (
    <div className="step-progress">
      <div className="step-progress__bar" style={{ "--ratio": ratio }} />

      <span className="step-progress__label">
        {ratio * maxValue} / {maxValue}
      </span>
    </div>
  );
}
